import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import globals from "../globals";

const ImpersonationBanner = () => {
    const { user, token, login, isImpersonating } = useAuth();
    const [loading, setLoading] = useState(false);

    if (!isImpersonating) {
        return null;
    }

    const displayName = [user?.first_name, user?.last_name].filter(Boolean).join(" ");

    const stopImpersonation = () => {
        setLoading(true);
        fetch(globals.apiUrl + "/auth/stop-impersonation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
            .then(async (response) => {
                const data = await response.json();
                if (!response.ok) {
                    throw new Error(data.detail || "Неуспешно спиране на прегледа");
                }
                login(data);
            })
            .catch((error) => {
                console.error("Error:", error);
                window.alert(error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Box
            sx={{
                position: "sticky",
                top: 0,
                zIndex: 1400,
                bgcolor: globals.colors.darkYellow,
                color: globals.colors.textColor,
                px: 2,
                py: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                flexWrap: "wrap",
            }}
        >
            <Typography fontWeight="bold" fontSize={14}>
                Преглеждате като {displayName || user?.email} ({user?.role})
            </Typography>
            <Button
                size="small"
                variant="contained"
                color="inherit"
                disabled={loading}
                onClick={stopImpersonation}
            >
                Обратно към админ
            </Button>
        </Box>
    );
};

export default ImpersonationBanner;
